export default __webpack_public_path__ + "2b7c358432c69138b83f5e3b662ab7a7.svg";